var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 32,
    viewBox: "0 0 108 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9862 27.4444H6.17981C5.3441 27.4444 4.66663 26.7706 4.66663 25.9393V4.06068C4.66663 3.22941 5.3441 2.55554 6.17981 2.55554H14.9079C20.7185 2.55554 23.3333 6.67359 23.3333 10.7916C23.3333 14.2956 21.4812 17.3661 17.45 18.3775L22.2205 25.0686C22.9311 26.0653 22.2146 27.4444 20.9862 27.4444Z",
    fill: "url(#paint0_linear_2645_1726)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M6.22218 2.55554H9.33329V27.4444H6.22218C5.36307 27.4444 4.66663 26.7706 4.66663 25.9393V4.06068C4.66663 3.22941 5.36307 2.55554 6.22218 2.55554Z",
    fill: "url(#paint1_linear_2645_1726)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6947 25H50.5091L46.5411 18.2416C48.5891 17.2944 49.9971 15.272 49.9971 13.0192C49.9971 9.74243 47.3347 7.08003 44.0323 7.08003H36.8643V25H40.3971V18.7792H43.0851L46.6947 25ZM40.3971 10.3824H44.0323C45.3635 10.3824 46.4643 11.5344 46.4643 13.0192C46.4643 14.504 45.3635 15.6816 44.0323 15.6816H40.3971V10.3824Z",
    fill: "#172B4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5761 19.9568H64.2273C64.3041 19.5216 64.3553 19.0864 64.3553 18.6C64.3553 14.8368 61.6673 11.8416 57.8785 11.8416C53.8593 11.8416 51.1201 14.7856 51.1201 18.6C51.1201 22.4144 53.8337 25.3584 58.1345 25.3584C60.5921 25.3584 62.5121 24.36 63.7153 22.6192L61.0529 21.0832C60.4897 21.8256 59.4657 22.3632 58.1857 22.3632C56.4449 22.3632 55.0369 21.6464 54.5761 19.9568ZM54.5249 17.3968C54.9089 15.7584 56.1121 14.8112 57.8785 14.8112C59.2609 14.8112 60.6433 15.5536 61.0529 17.3968H54.5249Z",
    fill: "#172B4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3655 12.2V13.7872C75.4695 12.584 74.0871 11.8416 72.2695 11.8416C68.6343 11.8416 65.8951 14.8112 65.8951 18.3952C65.8951 22.0048 68.6343 24.9488 72.2695 24.9488C74.0871 24.9488 75.4695 24.2064 76.3655 23.0032V24.3856C76.3655 26.408 75.0855 27.5344 73.0119 27.5344C71.0407 27.5344 70.1959 26.7408 69.6583 25.7424L66.8423 27.3552C67.9687 29.4288 70.1703 30.4784 72.9095 30.4784C76.2887 30.4784 79.5911 28.584 79.5911 24.3856V12.2H76.3655ZM72.7815 21.9024C70.7079 21.9024 69.1975 20.4432 69.1975 18.3952C69.1975 16.3728 70.7079 14.9136 72.7815 14.9136C74.8551 14.9136 76.3655 16.3728 76.3655 18.3952C76.3655 20.4432 74.8551 21.9024 72.7815 21.9024Z",
    fill: "#172B4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2241 10.664C85.3505 10.664 86.2721 9.74243 86.2721 8.64163C86.2721 7.54083 85.3505 6.59363 84.2241 6.59363C83.1233 6.59363 82.2017 7.54083 82.2017 8.64163C82.2017 9.74243 83.1233 10.664 84.2241 10.664ZM82.5857 25H85.8881V12.2H82.5857V25Z",
    fill: "#172B4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.6 7.08003H102.965L97.8451 15.5536L92.6995 7.08003H89.0643V25H92.5971V13.4032L97.6403 21.6976H98.0499L103.093 13.3776V25H106.6V7.08003Z",
    fill: "#172B4D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2645_1726",
    x1: 14.2905,
    y1: 2.55554,
    x2: 14.2905,
    y2: 27.4444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ED4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2645_1726",
    x1: 8.90663,
    y1: 2.55554,
    x2: 8.90663,
    y2: 27.4444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3525D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3525D3",
    stopOpacity: 0.24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4708c9a378202146baab523b5710daa8.svg";
export { ForwardRef as ReactComponent };